module.exports = __webpack_public_path__ + "static/hotel-androoms-nagoya-sakae-8cd229d45c134cb1bc4d3ac0937ad325.jpg";